import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NonNullableFormBuilder } from '@angular/forms';
import { uniqueId } from 'lodash-es';

@Component({
  selector: 'app-switch-button',
  templateUrl: './switch-button.component.html',
  styleUrl: './switch-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchButtonComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class SwitchButtonComponent implements ControlValueAccessor {
  @Input() tooltip = '';
  @Input() toggledIcon = 'fa-solid fa-check';
  @Input() untoggledIcon = 'fa-solid fa-check';

  readonly selectedValueControl = this.fb.control(false);
  readonly switchId = `app-switch-input-${uniqueId()}`;

  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private readonly fb: NonNullableFormBuilder) {
    this.selectedValueControl.valueChanges.subscribe((value) => {
      this.onChange(value);
      this.onTouched();
    });
  }

  get selectedValue(): boolean {
    return this.selectedValueControl.value;
  }

  set selectedValue(value: boolean) {
    this.selectedValueControl.setValue(value, { emitEvent: false });
  }

  writeValue(value: boolean): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.selectedValueControl.disable();
    } else {
      this.selectedValueControl.enable();
    }
  }
}
